import Vue from 'vue';

const mapping = {
  hamburger: '&#x1F354',
  'bowling-ball': '&#x1F3B3',
  jedi: '&#x1F52B',
  'ticket-alt': '&#x1F39F',
  'umbrella-beach': '&#x1F3D6',
  dumbbell: '🏋️‍♂️',
  gift: '🎁',
  'apple-alt': '🍏',
};
Vue.filter('formatEmoji', name => mapping[name] || name);

